module.exports = __webpack_public_path__ + "static/media/prepaid-card-silver-new-2021.6e48a526.jpg";